import React, { useState } from 'react';
import { StyledConnectLinkedinAccount } from '../EmailAccoutDetail.styles';
import { BiSolidCheckCircle } from 'react-icons/bi';
import { StepBtnsWrap } from '../../CreateCompaign/CreateCompaign.styles';
import Profile from './Profile';
import Proxy from './Proxy';
import Connection from './Connection';
import Verify from './Verify';

const ConnectAccountSteps = ({ onClose, activeProfile, isLinkedinLogin, onIframeStateChange }) => {
  const [step, setStep] = useState(activeProfile?.country === null ? 2 : activeProfile?.country ? 3 : 2);
  const [proxyLoading, setProxyLoading] = useState(false);
  const [accountData, setAccountData] = useState(null);
  const topStepButtons = [
    // { id: 1, label: 'Profile' },
    { id: 2, label: 'Proxy' },
    { id: 3, label: 'Connection' },
    { id: 4, label: 'Verify' },
  ];

  return (
    <StyledConnectLinkedinAccount>
      {!activeProfile?.country && (
        <StepBtnsWrap $margin="0">
          {topStepButtons.map(({ id, label }, index) => {
            const isActive = step === id;
            const isCompleted =
              topStepButtons.findIndex(btn => btn.id === id) < topStepButtons.findIndex(btn => btn.id === step);

            return (
              <span key={index} className={`step-btn ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
                <BiSolidCheckCircle className={isCompleted ? 'tick active' : 'tick'} />
                {label}
              </span>
            );
          })}
        </StepBtnsWrap>
      )}
      {/* {step === 1 && (
        <Profile setStep={setStep} onClose={onClose} setAccountData={setAccountData} accountData={accountData} />
      )} */}
      {step === 2 && (
        <Proxy
          setStep={setStep}
          onClose={onClose}
          setAccountData={setAccountData}
          accountData={accountData}
          activeProfile={activeProfile}
          proxyLoading={proxyLoading}
          setProxyLoading={setProxyLoading}
        />
      )}
      {step === 3 && (
        <Connection
          setStep={setStep}
          onClose={onClose}
          setAccountData={setAccountData}
          accountData={accountData}
          activeProfile={activeProfile}
          isLinkedinLogin={isLinkedinLogin}
          onIframeStateChange={onIframeStateChange}
          proxyLoading={proxyLoading}
          setProxyLoading={setProxyLoading}
        />
      )}
      {step === 4 && (
        <Verify setStep={setStep} onClose={onClose} accountData={accountData} activeProfile={activeProfile} />
      )}
    </StyledConnectLinkedinAccount>
  );
};

export default ConnectAccountSteps;
